import './Toolbar.scss';
import cn from 'classnames';
import { createContext, PropsWithChildren, useContext } from 'react';
import { Size, SizeType } from '../designConstants';

const ToolbarSizeContext = createContext<SizeType | undefined>(undefined);

/** An explicit size wins, then the enclosing Toolbar's size, then the fallback. */
export const useToolbarSize = (size?: SizeType, fallback: SizeType = Size.MD): SizeType => {
  const toolbarSize = useContext(ToolbarSizeContext);
  return size ?? toolbarSize ?? fallback;
};

/** Stops a Toolbar's size from reaching content that only renders under it (menus, popovers). */
export const ToolbarSizeReset = ({ children }: PropsWithChildren) => (
  <ToolbarSizeContext.Provider value={undefined}>{children}</ToolbarSizeContext.Provider>
);

interface ToolbarProps extends PropsWithChildren {
  size?: SizeType;
  className?: string;
}

export const Toolbar = ({ size = Size.MD, className, children }: ToolbarProps) => (
  <ToolbarSizeContext.Provider value={size}>
    <div className={cn('bpm-toolbar', className)}>{children}</div>
  </ToolbarSizeContext.Provider>
);
